const NotFoundPage = () => (
  <div
    style={{
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      textAlign: "center",
      width: "100%",
    }}
  >
    <h1 style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "24px" }}>
      صفحه مورد نظر یافت نشد
    </h1>
    <a
      href="/"
      style={{
        color: "blue",
        textDecoration: "none",
      }}
    >
      بازگشت به صفحه ورود
    </a>
  </div>
);

export default NotFoundPage;
